import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_445 implements Validator {

  public static id = 'CTRL_445';
  public LOG: LogService = new LogService(CTRL_445);
  private message = 'error.ctr_445';

  validate(form: any, map) {


    // vérifier si la règle est applicable sur mon formulaire
    const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_445.id + '_');
    if (rgs.length > 0) {
      for (let rg of rgs) {
        const ctrl = form.controls[rg];
        const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
        const firstChampCtrl = form.controls[firstChampNameWithStepId];
        if (!firstChampCtrl?.value || firstChampCtrl.value === 'yyyy-MM-dd') {
          form.controls[rg].value = {rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true};
          continue;
        }
        const toDay = new Date();
        if (form.value.formIntitule.includes('MAPA') || form.value.formIntitule.includes('divers')) {
          if (firstChampCtrl.value < formatDate(toDay.setDate(toDay.getDate() + 90), 'yyyy-MM-dd', 'en')) {
            form.controls[rg].value = {rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false};
          } else {
            // placer le message d'erreur
            form.controls[rg].value = {rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message};
          }
        } else {
          form.controls[rg].value = {rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false};
        }
      }
    }
  }
}
